import '@theme/gsap'
import { useReduced } from '@theme/maths'

const REVEAL_SELECTOR = '[data-load-reveal]'

const REVEAL = {
  shift: '2em',
  duration: 1.2,
  stagger: 0.05,
  ease: 'expo.out'
}

/** @returns {void} */
function playLoadReveal() {
  const targets = document.querySelectorAll(REVEAL_SELECTOR)
  if (targets.length === 0 || useReduced()) return

  window.gsap.from(targets, {
    y: REVEAL.shift,
    autoAlpha: 0,
    duration: REVEAL.duration,
    stagger: REVEAL.stagger,
    ease: REVEAL.ease,
    clearProps: 'all'
  })
}

playLoadReveal()
